import React from "react";
import "./App.css";
import Main from "./main";
import "antd/dist/antd.css";

function App() {
  return (
    <div className="App">
      <Main />
    </div>
  );
}

export default App;
